import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import moment from "moment";
import MachineOperatorAssociationFilter from "./MachineOperatorAssociationFilter";

const MachineOperatorAssociation = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [duration, setDuration] = useState("");

    const columns = [
        {
            accessor: "operator_name",
            header: "Operator Name",
            filterable: true,
        },
        {
            accessor: "machine_name",
            header: "Machine Name",
            filterable: true,
        },
        {
            accessor: "from_time",
            header: "From",
            cell: (row) => (
                <>
                    {row?.from_time
                        ? moment(row.from_time).format("DD MMM YYYY hh:mm A")
                        : "-"}
                </>
            ),
        },
        {
            accessor: "to_time",
            header: "To",
            cell: (row) => (
                <>
                    {row?.to_time
                        ? moment(row.to_time).format("DD MMM YYYY hh:mm A")
                        : "-"}
                </>
            ),
        },
    ];

    const { useFetch } = useAPIQuery({
        key: "api/operator-machine-association",
        endpoint: "/api/operator-machine-association/",
    });

    const { data, isLoading, isFetching } = useFetch(
        {
            params: {
                entries: entries,
                page_no: pageIndex + 1,
                date:
                    duration !== "" ? duration : moment().format("YYYY-MM-DD"),
                q:
                    globalFilterValue !== ""
                        ? globalFilterValue
                        : columnFilterValue,
                c: globalFilterValue === "" ? columnFilterKey : "",
            },
            abortOnNewRequest: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 3,
            retry: 3,
            keepPlaceholder: true,
            refetchOnReconnect: true,
        },
        [duration]
    );

    const handlePagination = (value) => {
        setSearchParams({
            entries: value.pageSize,
            page: value.pageIndex + 1,
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    const handleGlobalFilterChange = (value) => {
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Machine Operator Association
                        </h3>
                    </div>
                    <div className="d-flex align-items-center justify-content-center ms-auto">
                        <button
                            className="btn btn-icon btn btn-outline-primary rounded-pill me-3"
                            data-bs-toggle="modal"
                            data-bs-target="#machine-operator-association-filter-modal"
                        >
                            <em className="icon ni ni-filter-fill" />
                        </button>
                    </div>
                </div>
            </div>

            <Table
                data={data ? data?.results?.data : []}
                columns={columns}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={data ? data?.count : 0}
                isLoading={isLoading || isFetching}
                globalSearch
                filterModal={false}
                selectRows={false}
                editRows={false}
                deleteRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onPaginationChange={handlePagination}
            />
            <MachineOperatorAssociationFilter setDuration={setDuration} />
        </>
    );
};

export default MachineOperatorAssociation;
